module.exports = __webpack_public_path__ + "fonts/Space.381b20d.woff";